import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

interface ContactCdmAlertProps {
  message: string;
}

const ContactCdmAlert: React.FC<ContactCdmAlertProps> = ({ message }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: "100%",
        padding: "14px 16px",
        borderRadius: "8px",
        backgroundColor: theme.palette.background.canvas,
      }}
    >
      <Typography variant="body2">{message}</Typography>
    </Box>
  );
};

export default ContactCdmAlert;
